import {SelectionModel} from '@angular/cdk/collections';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort, Sort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {ProductStatus} from 'src/app/shared/enums/product-status.enum';

import {PageParams} from '../../../../core/models/page-params.model';
import {UserService} from '../../../../core/services/user.service';
import { ApplyHsCodeComponent } from '../../../../shared/components/apply-hs-code/apply-hs-code.component';
import { IShopBase } from '../../models/empact-product-details.interface';
import {OfflineShopService} from '../../services/offline-shop.service';
import { NotificationService } from 'src/app/core/services/notification.service';
@Component({
    selector: 'eci-table-products',
    templateUrl: './table-products.component.html',
    styleUrls: ['./table-products.component.scss'],
})
export class TableProductsComponent implements OnInit {
    private selection = new SelectionModel<any>(true, []);
    private listOfShop: IShopBase[];

    public constructor(
        private router: Router,
        private dialog: MatDialog,
        private productsSvc: OfflineShopService,
        private shopSvc: OfflineShopService,
        public userSvc: UserService,
        private notify: NotificationService
    ) {
    }

    @Input() public dataSource;
    @Input() public displayedColumns;
    @Input() public showDownloadBtn = true;
    @Input() public pageParams: PageParams = new PageParams();
    @Output() public pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>(null);
    @Output() public deleteProduct: EventEmitter<number> = new EventEmitter<number>(null);
    @Output() public changeProductStatus: EventEmitter<{ id: number; status: ProductStatus }> =
        new EventEmitter<{ id: number; status: ProductStatus }>(null);
    @Output() public sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
    @Output() public updateCategory = new EventEmitter<any>();
    @Output() public updateStatus = new EventEmitter<any>();
    @Output() public updateCompany = new EventEmitter<any>();
    @Output() public deleteIds = new EventEmitter<any>();
    @Output() public exportProductToExcel: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() public reloadData = new EventEmitter<any>();
    @ViewChild(MatSort) public sort: MatSort;
    @ViewChild('table', {static: true, read: ElementRef}) public table: ElementRef;

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin;
    }

    public pageChanged(e): void {
        this.pageChange.emit(e);
        this.table.nativeElement?.scrollIntoView();
    }

    public ngOnInit(): void {
        this.productsSvc.listOfShop$.subscribe((shops) => {
            this.listOfShop = shops;
        });
    }

    public navigateTo(id): void {
        this.router.navigate([`${this.router.url}/product-details/${id}`]);
    }

    public sortData(e: Sort): void {
        this.sortRows.emit(e);
    }

    public onChangeState(id, state): void {
        this.changeProductStatus.emit({
            id,
            status: state.checked ? ProductStatus.Active : ProductStatus.NotActive,
        });
    }

    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    public masterToggle(): void {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        this.selection.select(...this.dataSource);
    }

    /** The label for the checkbox on the passed row */
    public checkboxLabel(row?): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    public getShopName(shopId: string): string {
        const shop = this.listOfShop.find((el) => el.shopId === shopId);
        return shop ? `${shop.shopName}(${shopId})` : '';
    }

    public goToShop(shopId: string, productId: number): void {
        this.router.navigate([`/ecommerce/${shopId}/details/${productId}`], { queryParams: { redirectFromEmpact: true }});
    }

    applyHsCode(id?: number): void {
        let ids = !!id ? [id] : this.selection.selected.map(el => el.id);
        const dialogRef = this.dialog.open(ApplyHsCodeComponent, {
            data: ids,
            maxHeight: '90vh',
            height: '90vh',
            width: '90vw'
        });
        const info = ids;
        dialogRef.componentInstance.info = info;
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                const obj = {
                    productId: id,
                    hsCodeId: response.hscodeId,
                    hsCode: response.applyHSCodeSuccess
                }
                this.shopSvc.applyHsCodes(obj).subscribe(data => {
                    if (!data) {
                        this.notify.showError('Something went Wrong !!!');
                        return;
                    }
                    this.notify.showSuccessMessage('Hs Codes Applied Successfull');
                    this.reloadData.emit(data);
                    this.selection.clear();
                });
            }
        });
    }
}
